<template>
    <v-container>
        <v-card elevation="0">
            <v-card-text>
                <v-btn
                    class="mx-2"
                    fab
                    dark
                    color="blue"
                    @click="openSaveDialog(null)"
                >
                    <v-icon dark> mdi-plus </v-icon>
                </v-btn>

                <v-data-table
                    dense
                    :headers="headers"
                    :items="data"
                    item-key="id"
                    class="elevation-1 mt-3"
                    :options.sync="options"
                    :server-items-length="totalData"
                >
                    <template v-slot:item.fecha="{ item }">
                        <span v-if="item.fecha">{{
                            item.fecha | format_date
                        }}</span>
                        <span v-else class="grey--text">—</span>
                    </template>
                    <template v-slot:item.fecha_realizacion="{ item }">
                        <span v-if="item.fecha_realizacion">{{
                            item.fecha_realizacion | format_date
                        }}</span>
                        <span v-else class="grey--text">—</span>
                    </template>
                    <template v-slot:item.fecha_vencimiento="{ item }">
                        <span v-if="item.fecha_vencimiento">{{
                            item.fecha_vencimiento | format_date
                        }}</span>
                        <span v-else class="grey--text">—</span>
                    </template>
                    <template v-slot:item.aviso="{ item }">
                        {{ item.aviso ? "Si" : "No" }}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-icon
                            @click="openSaveDialog(item)"
                            small
                            class="mr-2"
                            color="#1d2735"
                            style="font-size: 25px"
                            title="EDITAR"
                            >mdi-pencil-outline</v-icon
                        >

                        <v-icon
                            @click="openDeleteDialog(item)"
                            small
                            class="mr-2"
                            color="red"
                            style="font-size: 25px"
                            title="BORRAR"
                            >mdi-trash-can</v-icon
                        >
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <v-dialog v-model="isDialogSaveVisible" max-width="960px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                    >{{
                        selectedItem.id ? "Editar" : "Crear"
                    }}
                    formación</v-card-title
                >
                <v-card-text>
                    <v-form ref="form" v-model="validForm">
                        <v-row class="mt-3" align="center">
                            <v-col cols="12" md="8">
                                <v-text-field
                                    v-model="selectedItem.nombre"
                                    label="Nombre"
                                    :rules="[rules.required]"
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-checkbox
                                    v-model="selectedItem.aviso"
                                    label="Aviso"
                                    style="margin-top: 0"
                                    class="mt-2"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="4">
                                <date-select
                                    v-model="selectedItem.fecha"
                                    label="Fecha"
                                    outlined
                                ></date-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <date-select
                                    v-model="selectedItem.fecha_realizacion"
                                    label="Fecha de realización"
                                    outlined
                                ></date-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <date-select
                                    v-model="selectedItem.fecha_vencimiento"
                                    label="Fecha de vencimiento"
                                    outlined
                                ></date-select>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-textarea
                                    v-model="selectedItem.observaciones"
                                    label="Observaciones"
                                    outlined
                                    dense
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                    <v-btn color="error" class="mr-2" @click="closeSaveDialog()"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" @click="saveFormacion"
                        >Guardar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <DeleteDialog
            v-model="isDialogDeleteVisible"
            @delete="deleteFormacion"
        ></DeleteDialog>
    </v-container>
</template>

<script>
import axios from "axios";
import DeleteDialog from "../../../components/general/dialogs/DeleteDialog.vue";
import { rules } from "../../../rules";
import dateSelect from "../../../components/general/dateSelect.vue";

export default {
    name: "FormacionesTab",
    props: ["userId"],
    components: {
        DeleteDialog,
        dateSelect,
    },
    data() {
        return {
            validForm: true,
            rules: rules,
            headers: [
                { text: "Nombre", value: "nombre", sortable: false },
                {
                    text: "Fecha",
                    value: "fecha",
                    sortable: false,
                },
                {
                    text: "Fecha de realización",
                    value: "fecha_realizacion",
                    sortable: false,
                },
                {
                    text: "Fecha de vencimiento",
                    value: "fecha_vencimiento",
                    sortable: false,
                },
                {
                    text: "Observaciones",
                    value: "observaciones",
                    sortable: false,
                },
                { text: "Aviso", value: "aviso", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            data: [],
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
            },
            totalData: 0,

            isDialogSaveVisible: false,
            isDialogDeleteVisible: false,
            selectedItem: {
                id: null,
                nombre: null,
                fecha: null,
                fecha_realizacion: null,
                fecha_vencimiento: null,
                observaciones: null,
                aviso: true,
            },
        };
    },
    created() {
        this.getFormaciones();
    },
    methods: {
        getFormaciones() {
            axios
                .get(`api/empleado/${this.userId}/formaciones`, {
                    params: this.options,
                })
                .then((res) => {
                    this.data = res.data.data;
                    this.totalData = res.data.total;
                });
        },

        // Crear o editar formación
        openSaveDialog(item) {
            if (item != null) {
                this.selectedItem = { ...item }; // Crear una copia
            } else {
                this.clearSelectedItem();
            }
            this.isDialogSaveVisible = true;
        },
        saveFormacion() {
            this.$refs.form.validate();
            if (!this.validForm) return;

            if (this.selectedItem.id == null) {
                // Crear formación
                axios
                    .post(
                        `api/empleado/${this.userId}/formaciones`,
                        this.selectedItem
                    )
                    .then((res) => {
                        this.$toast.sucs(
                            res.data.message ?? "Formación creada correctamente"
                        );
                        this.data.push(res.data.data);
                        this.totalData = this.totalData + 1;
                        this.clearSelectedItem();
                        this.isDialogSaveVisible = false;
                    })
                    .catch((err) => {
                        this.$custom_error(
                            err.response.data.message ??
                                "Error creando la formación"
                        );
                    });
            } else {
                // Editar formación
                axios
                    .put(
                        `api/empleado/${this.userId}/formaciones/${this.selectedItem.id}`,
                        this.selectedItem
                    )
                    .then((res) => {
                        this.$toast.sucs(
                            res.data.message ??
                                "Formación actualizada correctamente"
                        );
                        this.data = this.data.map((item) =>
                            item.id === this.selectedItem.id
                                ? res.data.data
                                : item
                        );
                        this.clearSelectedItem();
                        this.isDialogSaveVisible = false;
                    })
                    .catch((err) => {
                        this.$custom_error(
                            err.response.data.message ??
                                "Error actualizando la formación"
                        );
                    });
            }
        },
        closeSaveDialog() {
            this.clearSelectedItem();
            this.isDialogSaveVisible = false;
        },

        // Eliminar formación
        openDeleteDialog(item) {
            this.selectedItem = item;
            this.isDialogDeleteVisible = true;
        },
        deleteFormacion() {
            axios
                .delete(
                    `api/empleado/${this.userId}/formaciones/${this.selectedItem.id}`
                )
                .then((res) => {
                    this.$toast.sucs(
                        res.data.message ?? "Formación eliminada correctamente"
                    );
                    this.data = this.data.filter(
                        (item) => item.id !== this.selectedItem.id
                    );
                    this.totalData = this.totalData - 1;
                    this.clearSelectedItem();
                    this.isDialogDeleteVisible = false;
                })
                .catch((err) => {
                    this.$custom_error(
                        err.response.data.message ??
                            "Error eliminando la formación"
                    );
                });
        },

        clearSelectedItem() {
            this.selectedItem = {
                id: null,
                nombre: null,
                fecha: null,
                fecha_realizacion: null,
                fecha_vencimiento: null,
                observaciones: null,
                aviso: true,
            };
        },
    },
    watch: {
        //
    },
};
</script>
